 
import { OrderDashbordDay } from "../OrderDashbordDay";
import { OrderMonthlyLineChart } from "../OrderMonthlyLineChart";
 import OrderStatusChartAmountCustomer from "../OrderStatusChartAmountCustomer";
 import { Box, CircularProgress, Grid } from '@mui/material';
import { OrderYearlyLineChart } from "../OrderYearlyLineChart";
import { getUserData } from "../../auth";
import { useGetOrderStatusTotalByUserIdByDayQuery, useGetOrderStatusTotalByUserIdByMonthQuery, useGetOrderStatusTotalByUserIdByYearQuery } from "../../apis/OrderAPi";
  
 
const Customerdashbord = () => {

   // Extract user data from localStorage
    const userData = getUserData();
    const userId = userData?.uid ? Number(userData.uid) : 0; // Convert sellerId to a number
  
 // Fetch order data
  const { data, isLoading } = useGetOrderStatusTotalByUserIdByDayQuery({
    userId,
    isActive:false,
  });   
  const { data:monthlyData, isLoading:isLoadingMonthlyData } = useGetOrderStatusTotalByUserIdByMonthQuery({
    userId,
    isActive:false,
  });  

  const { data:yearlyData, isLoading:isLoadingYearlyData } = useGetOrderStatusTotalByUserIdByYearQuery({
    userId,
    isActive:false,
  });  
  
  if (isLoading || isLoadingMonthlyData ||isLoadingYearlyData)
      return (
        <div
          className="flex-center py-20"
          style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}
        >
          <CircularProgress sx={{ color: '#FFA500' }} />
        </div>
      );
  
  return (
    <>
 
     <div className="dashboard">
      <OrderStatusChartAmountCustomer/>

      <OrderDashbordDay data={data} />
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
             <OrderMonthlyLineChart data={monthlyData} />
         </Grid>
        
        <Grid item xs={12} md={6}>
 
            <OrderYearlyLineChart data={yearlyData} />         
         </Grid>
         
      </Grid>
    </div>
    
    </>
   
    
  );

};

export default Customerdashbord;